NtechApp.Slider = function($wrapper, slideClass, duration, minHeight, maxHeight) {
    var me = this;

    this._$wrapper = null;
    this._slideClass = null;

    this._$slides = null;

    this._currentSlide = 0;
    this._duration = 400;

    this._touchClickEvent = null;
    this._prefixer = null;
    this._dom = null;

    this._restoreTransitionTimeouts = [];

    this._resizeEventName = null;
    this._scrollEventName = null;

    this._minHeight = null;
    this._maxHeight = null;

    this._css = {
        ids: {
        },

        classes: {
        }
    };

    this._construct = function () {
        me._$wrapper = $wrapper;
        me._slideClass = slideClass;
        me._duration = duration || 400;

        var rand = Math.floor(Math.random() * (9999 - 1) + 1);
        me._resizeEventName = NtechApp.Slider.EVENT_DOCUMENT_RESIZE + (new Date).getTime() + rand;
        var rand = Math.floor(Math.random() * (9999 - 1) + 1);
        me._scrollEventName = NtechApp.Slider.EVENT_DOCUMENT_SCROLL + (new Date).getTime() + rand;

        me._touchClickEvent = new NtechApp.TouchClickEvent();
        me._prefixer = new NtechApp.Prefixer();
        me._dom = new NtechApp.Dom();

        me._minHeight = minHeight || null;
        me._maxHeight = maxHeight || null;

        me._findSlides();
        me._initSlides();
        me._makeAllSlidesVisible();
        me._adjustWrapperHeight();

        me._bindEvents();
    };

    this._bindEvents = function () {
        $(window).on(me._resizeEventName, function() {
            me._adjustSlides();
            me._adjustWrapperHeight();
        });

        $(document).on(me._scrollEventName, function() {

        });
    };

    this._unbindEvents = function () {
        $(window).off(me._resizeEventName);
        $(document).off(me._scrollEventName);
    };

    this.destruct = function () {
        me._unbindEvents();
    };

    this._construct();
    return this;
};

NtechApp.Slider.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Slider";
NtechApp.Slider.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.Slider";

NtechApp.Slider.prototype._findSlides = function() {
    this._$slides = this._$wrapper.find("." + this._slideClass);

    var me = this;
    window.slideTo = function(slideTo) {
        me.slideTo.call(me, slideTo);
    }
};

NtechApp.Slider.prototype._adjustWrapperHeight = function() {
    //var mostTallSlideHeight = 0;
    //$.each(this._$slides, function() {
    //    if($(this).outerHeight() > mostTallSlideHeight)
    //        mostTallSlideHeight = $(this).outerHeight();
    //});

    //this._$wrapper.height(mostTallSlideHeight);
    var newHeight = $(this._$slides.get(this._currentSlide)).outerHeight();
    if(this._minHeight != null && newHeight < this._minHeight)
        newHeight = this._minHeight;
    if(this._maxHeight != null && newHeight > this._maxHeight)
        newHeight = this._maxHeight;

    this._$wrapper.height(newHeight);
};

NtechApp.Slider.prototype._initSlides = function() {
    var me = this;
    var currentTranslateX = 0;

    $.each(this._$slides, function() {
        $(this).css({
            position: "absolute",
            left: "0px",
            top: "0px"
        });

        var item = $(this).get(0);

        me._dom.css3.transition(item, "opacity 0ms ease");

        //me._dom.css3.transform(item, "opacity(0)");
        //currentTranslateX += $(this).outerWidth() + 1;
        currentTranslateX += $(this).outerWidth();

        me._dom.css3.transition(item, "opacity " + me._duration + "ms ease");
        $(this).css("visibility", "visible");
    });
};

NtechApp.Slider.prototype._adjustSlides = function() { return;
    var slidesPositions = this._getSlidesPositions();

    for(var i = 0; i < this._restoreTransitionTimeouts.length; i++)
        clearTimeout(this._restoreTransitionTimeouts[i]);
    this._restoreTransitionTimeouts = [];

    for(var i = 0; i < slidesPositions.length; i++) {
        this._dom.css3.transition(
            this._$slides.get(i),
            //this._prefixer.getForCSS('transform', this._$slides.get(i)) + " 0ms ease"
            ""
        );

        this._dom.css3.transformProperty(
            this._$slides.get(i), "translate3d", slidesPositions[i] + "px,0px,0px"
        );

        var me = this;
        (function($slide) {
            var timeout = setTimeout(function() {
                me._dom.css3.transitionProperty(
                    $slide,
                    me._prefixer.getForCSS('transform', $slide) + " " + me._duration + "ms ease"
                );
            }, 100);
            me._restoreTransitionTimeouts.push(timeout);
        })(this._$slides.get(i));
    }
};

NtechApp.Slider.prototype._makeAllSlidesVisible = function() {
    $.each(this._$slides, function() {
        $(this).css("visibility", "visible");
    });
};

NtechApp.Slider.prototype._getSlidesPositions = function() {
    var slidesPositions = [];
    var nextPosition = 0;

    $.each(this._$slides, function() {
        slidesPositions.push(nextPosition);
        //nextPosition += $(this).outerWidth() + 1;
        nextPosition += $(this).outerWidth();
    });

    if(this._currentSlide != 0) {
        for(var i = 1; i <= this._currentSlide; i++) {
            for(var j = 0; j < slidesPositions.length; j++) {
                slidesPositions[j] -= $(this._$slides.get(j)).outerWidth();
                // slidesPositions[j] -= $(this._$slides.get(j)).outerWidth();
            }
        }
    }

    return slidesPositions;
};

NtechApp.Slider.prototype.slideTo = function(slide) {
    this._currentSlide = slide;
    this._adjustWrapperHeight();

    var slidesPositions = this._getSlidesPositions();

    for(var i = 0; i < slidesPositions.length; i++) {
        //this._dom.css3.transform(this._$slides.get(i), "translate3d(" + slidesPositions[i] + ",0px,0px)");
        // this._dom.css3.transformProperty(
        //     this._$slides.get(i), "translate3d", slidesPositions[i] + "px,0px,0px"
        // );
        this._$slides.get(i).style.opacity = 0;
        this._$slides.get(i).style.zIndex = 1;
    }

    this._$slides.get(this._currentSlide).style.opacity = 1;
    this._$slides.get(this._currentSlide).style.zIndex = 2;
};
/*
NtechApp.Slider = function($wrapper, slideClass, duration, minHeight, maxHeight) {
    var me = this;

    this._$wrapper = null;
    this._slideClass = null;

    this._$slides = null;

    this._currentSlide = 0;
    this._duration = 400;

    this._touchClickEvent = null;
    this._prefixer = null;
    this._dom = null;

    this._restoreTransitionTimeouts = [];

    this._resizeEventName = null;
    this._scrollEventName = null;

    this._minHeight = null;
    this._maxHeight = null;

    this._css = {
        ids: {
        },

        classes: {
        }
    };

    this._construct = function () {
        me._$wrapper = $wrapper;
        me._slideClass = slideClass;
        me._duration = duration || 400;

        var rand = Math.floor(Math.random() * (9999 - 1) + 1);
        me._resizeEventName = NtechApp.Slider.EVENT_DOCUMENT_RESIZE + (new Date).getTime() + rand;
        var rand = Math.floor(Math.random() * (9999 - 1) + 1);
        me._scrollEventName = NtechApp.Slider.EVENT_DOCUMENT_SCROLL + (new Date).getTime() + rand;

        me._touchClickEvent = new NtechApp.TouchClickEvent();
        me._prefixer = new NtechApp.Prefixer();
        me._dom = new NtechApp.Dom();

        me._minHeight = minHeight || null;
        me._maxHeight = maxHeight || null;

        me._findSlides();
        me._initSlides();
        me._makeAllSlidesVisible();
        me._adjustWrapperHeight();

        me._bindEvents();
    };

    this._bindEvents = function () {
        $(window).on(me._resizeEventName, function() {
            me._adjustSlides();
            me._adjustWrapperHeight();
        });

        $(document).on(me._scrollEventName, function() {

        });
    };

    this._unbindEvents = function () {
        $(window).off(me._resizeEventName);
        $(document).off(me._scrollEventName);
    };

    this.destruct = function () {
        me._unbindEvents();
    };

    this._construct();
    return this;
};

NtechApp.Slider.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Slider";
NtechApp.Slider.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.Slider";

NtechApp.Slider.prototype._findSlides = function() {
    this._$slides = this._$wrapper.find("." + this._slideClass);

    var me = this;
    window.slideTo = function(slideTo) {
        me.slideTo.call(me, slideTo);
    }
};

NtechApp.Slider.prototype._adjustWrapperHeight = function() {
    //var mostTallSlideHeight = 0;
    //$.each(this._$slides, function() {
    //    if($(this).outerHeight() > mostTallSlideHeight)
    //        mostTallSlideHeight = $(this).outerHeight();
    //});

    //this._$wrapper.height(mostTallSlideHeight);
    var newHeight = $(this._$slides.get(this._currentSlide)).outerHeight();
    if(this._minHeight != null && newHeight < this._minHeight)
        newHeight = this._minHeight;
    if(this._maxHeight != null && newHeight > this._maxHeight)
        newHeight = this._maxHeight;

    this._$wrapper.height(newHeight);
};

NtechApp.Slider.prototype._initSlides = function() {
    var me = this;
    var currentTranslateX = 0;

    $.each(this._$slides, function() {
        $(this).css({
            position: "absolute",
            left: "0px",
            top: "0px"
        });

        var item = $(this).get(0);

        me._dom.css3.transition(item, me._prefixer.getForCSS('transform', item) + " 0ms ease");

        me._dom.css3.transform(item, "translate3d(" + currentTranslateX + "px,0px,0px)");
        //currentTranslateX += $(this).outerWidth() + 1;
        currentTranslateX += $(this).outerWidth();

        me._dom.css3.transition(item, me._prefixer.getForCSS('transform', item) + " " + me._duration + "ms ease");
        $(this).css("visibility", "visible");
    });
};

NtechApp.Slider.prototype._adjustSlides = function() {
    var slidesPositions = this._getSlidesPositions();

    for(var i = 0; i < this._restoreTransitionTimeouts.length; i++)
        clearTimeout(this._restoreTransitionTimeouts[i]);
    this._restoreTransitionTimeouts = [];

    for(var i = 0; i < slidesPositions.length; i++) {
        this._dom.css3.transition(
            this._$slides.get(i),
            //this._prefixer.getForCSS('transform', this._$slides.get(i)) + " 0ms ease"
            ""
        );

        this._dom.css3.transformProperty(
            this._$slides.get(i), "translate3d", slidesPositions[i] + "px,0px,0px"
        );

        var me = this;
        (function($slide) {
            var timeout = setTimeout(function() {
                me._dom.css3.transitionProperty(
                    $slide,
                    me._prefixer.getForCSS('transform', $slide) + " " + me._duration + "ms ease"
                );
            }, 100);
            me._restoreTransitionTimeouts.push(timeout);
        })(this._$slides.get(i));
    }
};

NtechApp.Slider.prototype._makeAllSlidesVisible = function() {
    $.each(this._$slides, function() {
        $(this).css("visibility", "visible");
    });
};

NtechApp.Slider.prototype._getSlidesPositions = function() {
    var slidesPositions = [];
    var nextPosition = 0;

    $.each(this._$slides, function() {
        slidesPositions.push(nextPosition);
        //nextPosition += $(this).outerWidth() + 1;
        nextPosition += $(this).outerWidth();
    });

    if(this._currentSlide != 0) {
        for(var i = 1; i <= this._currentSlide; i++) {
            for(var j = 0; j < slidesPositions.length; j++) {
                slidesPositions[j] -= $(this._$slides.get(j)).outerWidth();
                // slidesPositions[j] -= $(this._$slides.get(j)).outerWidth();
            }
        }
    }

    return slidesPositions;
};

NtechApp.Slider.prototype.slideTo = function(slide) {
    this._currentSlide = slide;
    this._adjustWrapperHeight();

    var slidesPositions = this._getSlidesPositions();

    for(var i = 0; i < slidesPositions.length; i++) {
        //this._dom.css3.transform(this._$slides.get(i), "translate3d(" + slidesPositions[i] + ",0px,0px)");
        this._dom.css3.transformProperty(
            this._$slides.get(i), "translate3d", slidesPositions[i] + "px,0px,0px"
        );
    }
};
*/